export const PUBLISHED_DATE_OPTIONS = [
  { label: "Any time", value: "any-time", is_selected: false },
  { label: "Recent", value: "recent", is_selected: false },
  { label: "Today", value: "today", is_selected: false },
  { label: "Past 7 Days", value: "seven-days", is_selected: false },
  { label: "Past Month", value: "past-month", is_selected: false },
  { label: "Past Year", value: "past-year", is_selected: false },
];

export const FILTER_BY_TYPE_OPTIONS = [
  { label: "All", value: "all", is_selected: false },
  { label: "PDF", value: "file", is_selected: false },
  { label: "Platform Content", value: "content", is_selected: false },
];

export const REPORT_TYPE_OPTIONS = [
  { id: 1, name: "All", value: "", is_selected: true },
  { id: 2, name: "Company Research", value: "company", is_selected: false },
  { id: 3, name: "Benchmarks", value: "benchmark", is_selected: false },
  {
    id: 4,
    name: "Market Forecast",
    value: "market_forecast",
    is_selected: false,
  },
  {
    id: 5,
    name: "Market Landscape",
    value: "market_landscape",
    is_selected: false,
  },
  {
    id: 6,
    name: "Special Report",
    value: "special_report",
    is_selected: false,
  },
  { id: 7, name: "Project", value: "project", is_selected: false },
  {
    id: 8,
    name: "Customer Study",
    value: "customer_study",
    is_selected: false,
  },
  { id: 9, name: "Ecosystem", value: "ecosystem", is_selected: false },
];

export const GO_TO_ALL_LINKS = [
  "Board",
  "Visualization",
  "Preferences Center",
  "Project",
];

export const LEGENDS = [
  {
    icon: "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/company_os_icon.svg",
    label: "Company Research",
  },
  {
    icon: "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/benchmark_os_icon.svg",
    label: "Benchmarks",
  },
  {
    icon: "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/marketforecast_os_icon.svg",
    label: "Market Forecasts",
  },
  {
    icon: "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/marketlandscape_os_icon.svg",
    label: "Market Landscapes",
  },
  {
    icon: "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/specialreport_os_icon.svg",
    label: "Special Reports",
  },
  {
    icon: "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/project_os_icon.svg",
    label: "Projects",
  },
  {
    icon: "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/customerstudy_os_icon.svg",
    label: "Customer Studies",
  },
  {
    icon: "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/ecosystem_os_icon.svg",
    label: "Ecosystems",
  },
  {
    icon: "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/pdf_os_icon.svg",
    label: "Pdf",
  },
];
